import pauseAnimation from './pauseAnimation.js'
import mainNav from './mainNav.js'

function ready () {
	'use strict'

	pauseAnimation()
	mainNav()
}
document.addEventListener( 'DOMContentLoaded', ready )
